import { EntityRatingCommentCount, Rating } from '@medprev-web-app/api-graphql-client';
import { ReactNode } from 'react';

import { EntityRating } from '@/app/(main)/(pages)/_components/entities/entity-rating-sumary.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { AnalyticsEnumKeyType } from '@/types/enums/analytics/analytics.enum';

interface EntityProfileHeaderProps {
  avatar: ReactNode;
  name: string;
  subtitle?: ReactNode;
  rating?: Rating | null;
  commentsCount?: EntityRatingCommentCount | null;
  actions?: ReactNode;
  dataTestId?: string;
  ratingAnalyticsEvent?: AnalyticsEnumKeyType;
}

export function EntityProfileHeader({
  avatar,
  name,
  subtitle,
  rating,
  commentsCount,
  actions,
  dataTestId,
  ratingAnalyticsEvent,
}: EntityProfileHeaderProps) {
  return (
    <>
      <div
        className="flex flex-col items-center gap-4 pb-6 md:flex-row md:items-start"
        data-testid={dataTestId}
      >
        <div className="shrink-0">{avatar}</div>

        <div className="flex flex-col gap-2">
          <Typography
            variant={TypographyVariant.MODAL_TITLE}
            as="h1"
            className="text-center md:text-left break-words text-wrap hyphens-auto overflow-hidden"
          >
            {name}
          </Typography>

          <div className="text-center md:text-left">
            {subtitle}
          </div>
        </div>
      </div>

      <EntityRating
        rating={rating}
        commentsCount={commentsCount}
        data-analytics-event={ratingAnalyticsEvent}
      />

      <div className="py-4">
        {actions}
      </div>
    </>
  );
}
